export const OTHER_FUNDING_TYPE_CODE = 'other'
